import { Link } from 'react-router-dom'
import * as React from 'react'
import styled from 'styled-components'

import { Button } from '../../atoms/Button'
import { Content } from '../../atoms/Content/index'
import { MenuPage } from '../MenuPage'
import { P } from '../../atoms/P'
import { media } from '../../utils/media'
import welcomeBackImg from './welcome-back.png'
import welcomeBackImg2x from './welcome-back@2x.png'

import { withRouter } from 'react-router'

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

const KidsForbidden = withRouter(class MyClass extends MenuPage {
  public renderContent() {
    return (
      <Content>
        <RowTablet>

          <ColRight>
            <H2>{lang === 'en' ? 'You need to finish the parent site first!' : '¡Primero debe terminar el Sitio para Padres!'}</H2>
            <P>
              {lang === 'en' ? `You must complete all sections of the Parent's Site before moving on to the Kid's Space. The more you learn by going through the Parent's Site, the easier this process will be for you and your child. By reading all of the information and answering all of the questions, you will be more prepared to help your child cope before and after surgery.` : `Debe leer todas las secciones del Sitio para padres antes de pasar al Espacio para niños. Cuanto más aprenda visitando el sitio para padres, más fácil será este proceso. Lo que aprenda en el sitio para padres le ayudará a usted y a su hijo en el proceso de la cirugía. Así estará más preparado para ayudar a su hijo a estar tranquilo antes y después de la cirugía.`}
            </P>

            <WelcomeBackImgMobile
              src="https://uci-images.s3-us-west-1.amazonaws.com/images/hero.png"
              srcSet={`https://uci-images.s3-us-west-1.amazonaws.com/images/hero@2x.png 2x`} />
            <P>
              {lang === 'en' ? `At the end of the Home After Surgery section, you will be able to access the Kid's Space!` : `¡Al final de la sección En Casa Después de la Cirugía, podrá acceder al Sitio para Niños!`}
            </P>
            <ButtonContainer>
              <Button onClick={() => this.props.history.goBack()}>{lang === 'es' ? 'regresa' : 'Back'}</Button>
            </ButtonContainer>
          </ColRight>

          <WelcomeBackImg
            src="https://uci-images.s3-us-west-1.amazonaws.com/images/hero.png"
            srcSet={`https://uci-images.s3-us-west-1.amazonaws.com/images/hero@2x.png 2x`} />


          </RowTablet>
        </Content>
    )
  }
})

export {KidsForbidden}

const RowTablet = styled.div`
  margin-top: 12px;
  ${media.tablet`
    display: flex;
    align-items: center;
  `}
`

const WelcomeBackImg = styled.img`
  display: none;

  ${media.tablet`
    flex: 0 0 auto;
    display: block;
  `}
`

const WelcomeBackImgMobile = styled.img`
  flex: 0 0 auto;
  display: block;
  ${media.tablet`
    display: none;
  `}
`

const ColRight = styled.div`
  flex: 1 1 auto;
  margin-bottom: 30px;
`

const H1 = styled.h1`
  font-family: Nunito;
  font-weight: 900;
  font-size: 35px;
  color: #12385b;

  ${media.tablet`
    font-size: 54px;
  `}
`

const H2 = styled.h2`
  font-family: Nunito;
  font-size: 20px;
  font-weight: 600;
  color: #12385b;

  ${media.tablet`
    font-size: 24px;
  `}
`

const ButtonContainer = styled.div`
  margin-top: 40px;
  text-align: center;

  ${media.tablet`
    text-align: left;
  `}
`



// WEBPACK FOOTER //
// ./src/pages/KidsForbidden/index.tsx